import React, { useContext, useState, useEffect } from "react";
import { Col, Row, Button, Card } from "react-bootstrap";
import Statics from "../Statics";
import { useParams } from "react-router-dom";
import ComponentContext from "../Context";
import DocumentMeta from "react-document-meta";
import HeaderBanner from "../Components/HeaderBanner";
import Kargah from "../Images/kargah.png";
import {
  cancelWorkshopRegistration,
  fetchWorkshopPaymentLink,
  fetchWorkshopRegistration,
} from "../lib/workshopApi";

const REGISTRATION_STATUS = {
  PENDING: 1,
  COMPLETED: 2,
  CANCELED: 3,
};

const WORKSHOP_STATUS = {
  PENDING: 2,
  ACTIVE: 3,
  COMPLETED: 5,
  CANCELED: 6,
};

export default () => {
  const { workshop_id, status } = useParams();
  const context = useContext(ComponentContext);
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);
  const [person, set_person] = useState({});

  const page_meta = {
    language: "fa",
    copyright: "پژوهیار",
    description: "نرم‌افزار استناددهی",
    title: "پرداخت | کارگاه",
    meta: {
      charset: "utf-8",
      name: {
        keywords: "پژوهیار",
      },
    },
  };

  const body = `به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر گرفته شده است. برای
      درخواست کارگاه و کلاس آموزشی از طریق فرم تربیت‌مدرس، فرم سازمانی و فرم عمومی ثبت نام فرمایید.`;

  useEffect(() => {
    if (loading_state === Statics.NOT_LOADED) {
      getRegisterationData();
    }
    // eslint-disable-next-line
  }, [loading_state]);

  const getRegisterationData = () => {
    set_loading_state(Statics.LOADING);
    fetchWorkshopRegistration(workshop_id)
      .then(data => {
        set_person(data);
        set_loading_state(Statics.LOADED);
      })
      .catch(() => {
        set_loading_state(Statics.CAUSED_ERROR);
      });
  };

  const cancelRegisteration = () => {
    set_loading_state(Statics.LOADING);
    cancelWorkshopRegistration(workshop_id)
      .then(() => {
        set_loading_state(Statics.LOADED);
        context.notification("ثبت نام با موفقیت لغو شد.", "success");
        window.location = "/workshop";
      })
      .catch(() => {
        set_loading_state(Statics.CAUSED_ERROR);
      });
  };

  const generatePaylink = () => {
    fetchWorkshopPaymentLink(workshop_id)
      .then(data => {
        window.location = data.link;
      })
      .catch(error => {
        context.notification(
          error?.message || "دریافت لینک پرداخت انجام نشد.",
          "error",
        );
      });
  };

  const renderWorkshopSessions = () => {
    if (!person.workshop?.meetings?.data?.length) return null;

    return person.workshop.meetings.data.map((session, index) => (
      <Row key={index}>
        <p>
          جلسه {index + 1}: {"\u00A0"}
          <label>
            {`${session.start_date.year}/${session.start_date.month}/${
              session.start_date.day
            } ${session.start_date.hour}:${session.start_date.minute
              .toString()
              .padStart(2, "0")}`}
          </label>
          {"\u00A0"}تا{"\u00A0"}
          <label>
            {`${session.finish_date.hour}:${session.finish_date.minute
              .toString()
              .padStart(2, "0")}`}
          </label>
        </p>
      </Row>
    ));
  };

  const renderPersonalInfo = () => {
    const fields = [
      ["نام", person.first_name], ["نام خانوادگی", person.last_name],
      ["کد ملی", person.id_number], ["تاریخ تولد", person.birth_date],
      ["دانشگاه", person.university], ["رشته", person.field],
      ["مقطع", person.grade], ["شغل", person.job], ["آدرس", person.address],
    ].filter(([, value]) => value && String(value).trim().toLowerCase() !== "null");

    return <Row>{fields.map(([label, value]) => <Col md={6} key={label}><Row><label>{label}:</label><label>{value}</label></Row></Col>)}</Row>;
  };

  const renderActionButtons = () => {
    if (!person.status || !person.workshop?.status) return null;

    const regStatus = person.status.code;
    const wsStatus = person.workshop.status.code;

    if (regStatus === REGISTRATION_STATUS.CANCELED) {
      return (
        <Row className="pt-3 pb-3 justify-content-center">
          <Button variant="secondary" disabled>
            شما از این کارگاه انصراف داده‌اید
          </Button>
        </Row>
      );
    }

    if (regStatus === REGISTRATION_STATUS.COMPLETED || status === "success") {
      return (
        <Row className="pt-3 pb-3 justify-content-center">
          <div  className="no-hover-btn">
            پرداخت با موفقیت انجام شد. با شما تماس گرفته خواهد شد.
          </div>
        </Row>
      );
    }

    if ((!status || status === "failed") && person.can_pay) {
      return (
        <Row className="pt-3 pb-3 justify-content-around">
          <Button variant="success" onClick={generatePaylink}>
            پرداخت
          </Button>
          {person.can_cancel && <Button variant="danger" onClick={cancelRegisteration}>انصراف</Button>}
        </Row>
      );
    }

    if (person.can_cancel) {
      return <Row className="pt-3 pb-3 justify-content-center"><Button variant="info" disabled>رزرو شما با موفقیت ثبت شد. پس از انجام پرداخت، اطلاعات تأیید رزرو از طریق ایمیل برای شما ارسال خواهد شد.</Button><Button className="mr-2" variant="danger" onClick={cancelRegisteration}>لغو رزرو</Button></Row>;
    }

    if (
      regStatus === REGISTRATION_STATUS.PENDING &&
      wsStatus === WORKSHOP_STATUS.PENDING
    ) {
      return (
        <>
          <Row className="pt-3 pb-3 justify-content-center">
            <Button variant="info" disabled>
              ثبت‌نام شما انجام شد. در صورت تشکیل کارگاه با شما تماس می‌گیریم.
            </Button>
          </Row>
          <Row className="pt-3 pb-3 justify-content-center">
            <Button variant="danger" onClick={cancelRegisteration}>
              انصراف
            </Button>
          </Row>
        </>
      );
    }

    if (wsStatus === WORKSHOP_STATUS.CANCELED) {
      return "کارگاه لغو شده است.";
    }

    return null;
  };

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner body={body} image={Kargah} header_color="#E5E1DA" />

      {loading_state === Statics.LOADED && (
        <Row className="mx-0 justify-content-center pt-5">
          <Col md={8} className="text-right">
            {renderActionButtons()}
            <Row>
              <Card>
                <Card.Header>اطلاعات کارگاه</Card.Header>
                <Card.Body>
                  <Row>
                    <Col>
                      <Row>
                        <label>نام کارگاه:</label>
                        {"\u00A0"}
                        <label>{person.workshop.title}</label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>توضیحات:</label>
                        {"\u00A0"}
                        <label>{person.workshop.description}</label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>قیمت:</label>
                        {"\u00A0"}
                        <label>
                          {person.workshop.offered_fee.toLocaleString()} ریال
                        </label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row>
                        <label>نوع کارگاه:</label>
                        {"\u00A0"}
                        <label>{person.workshop.type.text}</label>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>{renderWorkshopSessions()}</Col>
                  </Row>
                </Card.Body>
              </Card>
            </Row>

            <Row className="pb-5">
              <Card>
                <Card.Header>اطلاعات فردی</Card.Header>
                <Card.Body>{renderPersonalInfo()}</Card.Body>
              </Card>
            </Row>

            
          </Col>
        </Row>
      )}

      {loading_state === Statics.LOADING && (
        <div className="text-center py-5">در حال بارگیری اطلاعات...</div>
      )}

      {loading_state === Statics.CAUSED_ERROR && (
        <div className="text-center py-5 text-danger">
          خطا در دریافت اطلاعات. لطفاً دوباره تلاش کنید.
        </div>
      )}
    </DocumentMeta>
  );
};
